import * as React from 'react';
import autobind from 'autobind-decorator';
import { observable } from 'mobx';
import { observer } from 'mobx-react';
import * as uuid from 'uuid';

import { NoteListView } from './note-list.view';
import { IdentityService } from 'src/core/services/identity.service';
import { DataLocalService } from 'src/core/services/data-local.service';

interface NoteListControllerProps extends ComponentViewProps<NoteItem[]> {
	mode: ControlMode;
	identityService: IdentityService;
	isModal: boolean
	setDeleteNode?: (noteDelete: NoteItem) => void
}

@observer
export class NoteListController extends React.Component<NoteListControllerProps, any> {
	@observable
	private dataSet: DataLocalService<NoteItem>;

	@autobind
	deleteNote(noteDelete: NoteItem, parent: NoteItem) {

		let index = this.props.model.findIndex(x => x.id == noteDelete.id);
		if (index >= 0) {
			this.dataSet.delete([noteDelete]);
			
		} else if (parent.children) {
			let indexChild = parent.children.findIndex(x => x.id == noteDelete.id);
			if (indexChild >= 0) {
				parent.children.splice(indexChild, 1);

			}
		}
		if (this.props.setDeleteNode)
			this.props.setDeleteNode(noteDelete);
	}

	@autobind
	private response(parent: NoteItem) {
		let noteResponse: NoteItem = {
			id: this.props.isModal ? `create${uuid.v4()}` : uuid.v4(),
			title: null,
			type: 'Information',
			visibility: { client: [], agent: [], supplier: [] },
			creationDate: new Date(),
			userName: this.props.identityService.username,
			msg: '',
			html: ''
		};
		if (parent.children == null) {
			parent.children = [];
		}

		parent.children.push(noteResponse);
		return noteResponse;
	}

	@autobind
	private async addNote() {
		const res = await this.dataSet.create(() => ({
			id: this.props.isModal ? `create${uuid.v4()}` : uuid.v4(),
			title: null,
			type: 'Information',
			visibility: { client: [], agent: [], supplier: [] },
			creationDate: new Date(),
			userName: this.props.identityService.username,
			msg: '',
			html: '',
			children: []
		}));
		return res;
	}

	componentWillReceiveProps(nextProps: Readonly<NoteListControllerProps>, nextContext: any) {
		this.dataSet = new DataLocalService(nextProps.model);
	}

	componentDidMount() {
		this.componentWillReceiveProps(this.props, null);

	}

	public render() {
		if (this.dataSet == null) {
			return null;
		}
		return (
			<NoteListView
				addNote={this.addNote}
				deleteNote={this.deleteNote}
				response={this.response}
				identityService={this.props.identityService}
				setBusy={this.props.setBusy}
				model={this.dataSet.items}
				parentMode={this.props.mode}
			/>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/general/notes/list/note-list.controller.tsx